module.exports = __webpack_public_path__ + "static/media/nav_card_icon_1.052e7174.svg";